export const DRAWING_KIND_ARKITEKT = "arkitekt";
export const DRAWING_KIND_VENTILASJON = "ventilasjon";
export const DRAWING_KIND_KJOKKEN = "kjokken";
export const DRAWING_KIND_ANNET = "annet";

export const DRAWING_KINDS = [
  DRAWING_KIND_ARKITEKT,
  DRAWING_KIND_VENTILASJON,
  DRAWING_KIND_KJOKKEN,
  DRAWING_KIND_ANNET,
];

export const DEFAULT_DRAWING_KIND = DRAWING_KIND_ARKITEKT;

export const drawingKindLabel = (t, kind) => {
  const key = kind || DEFAULT_DRAWING_KIND;
  return t(`drawings.kind.${key}`, { defaultValue: key });
};

export const isValidDrawingKind = (value) => DRAWING_KINDS.includes(value);
